import instance from "../components/general/AxiosInterceptor";
const controller = "/api/auth";

export const loginApi = async (username, password, captchaResponse) => {
  const response = await instance.post(`${controller}/login`, {
    username,
    password,
    captchaResponse
  });
  return response.data;
};



export const forgotPasswordApi = async (email) => {
  const response = await instance.post(`${controller}/request-password-reset`, { email });
  return response.data;
};

export const createAccountApi = (payload) => {
  return instance.post(`${controller}/create-manufacturer`, payload);
};



export const verifyResetCodeApi = async (email, verificationCode) => {
  const response = await instance.post(`${controller}/verify-code`, { email, verificationCode });
  return response.data;
};

export const resetPasswordApi = async (email, newPassword, confirmPassword) => {
  const response = await instance.post(`${controller}/reset-password`,
    {
      email,
      newPassword,
      confirmPassword
    });
  return response.data;
};
